// Reine, testbare Ableitung des Alarmzustands aus der MENGE offener
// awaiting_merchant-Orders (kein globales Boolean, kein „letztes Event").
// Solange >=1 Order awaiting_merchant ist, bleibt der Alarm aktiv.
import { isAwaitingMerchant, type TerminalOrder } from "../lib/types";

export interface AlarmState {
  active: boolean;
  openCount: number;
  openOrderIds: string[];
  // true, sobald eine NEUE offene Order hinzukommt oder ein Reminder für
  // eine weiterhin offene Order eintrifft => (erneuter) Klingelimpuls.
  shouldPulse: boolean;
}

export function computeAlarmState(
  orders: TerminalOrder[],
  prevOpenIds: ReadonlySet<string>,
  reminderOrderIds: ReadonlySet<string> = new Set(),
): AlarmState {
  const open = orders.filter(isAwaitingMerchant);
  const openOrderIds = open.map((o) => o.order_id);
  const openSet = new Set(openOrderIds);

  let hasNew = false;
  for (const id of openSet) {
    if (!prevOpenIds.has(id)) { hasNew = true; break; }
  }
  let hasActiveReminder = false;
  for (const id of reminderOrderIds) {
    if (openSet.has(id)) { hasActiveReminder = true; break; }
  }

  return {
    active: openSet.size > 0,
    openCount: openSet.size,
    openOrderIds,
    shouldPulse: openSet.size > 0 && (hasNew || hasActiveReminder),
  };
}
